import { combineReducers } from "redux";
import accountReducer  from "../components/domain/accounts/accountReducer";
import homePageReducer from "../components/domain/homePage/homePageReducer";
import submitURLReducer from "../components/domain/submitURL/submitURLReducer";
import postReducer from "../components/domain/post/postReducer";
import userBoomarksReducer from "../components/domain/userBookmarks/userBookmarksReducer";

import { reducer as toastrReducer } from 'react-redux-toastr';

export default combineReducers({
    userAccount: accountReducer,
    toastr: toastrReducer,
    homePage: homePageReducer,
    submitURL: submitURLReducer,
    post: postReducer,
    userBookmarks: userBoomarksReducer,
});
